module.exports = __webpack_public_path__ + "static/FLP-fdbe043f47d44f44e61896881fb3cb0b.png";